import * as types from "./actionTypes";

export const markDocumentReadCompleatFood = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_COMPLEAT_FOOD,
  payload: documentFilename,
});

export const setCompleatFoodReadingLoading = (isLoading) => {
  return {
    type: types.SET_COMPLEAT_FOOD_READING_LOADING,
    payload: isLoading,
  };
};

export const setCompleatFoodFormLoading = (formName) => ({
  type: types.SET_COMPLEAT_FOOD_FORM_LOADING,
  payload: formName,
});

export const postCompleatFoodForm = (formName, formContent) => ({
  type: types.POST_COMPLEAT_FOOD_FORM,
  payload: { formName, formContent },
});
